import { TextAlign, TextFontFamily } from '@/types/personalization';

export const TEXT_FONT_OPTIONS: { value: TextFontFamily; label: string; preview: string }[] = [
	{ value: 'inter', label: 'Inter', preview: 'Nowoczesny, czytelny sans-serif' },
	{ value: 'montserrat', label: 'Montserrat', preview: 'Wyraźny krój geometryczny' },
	{ value: 'playfair', label: 'Playfair Display', preview: 'Elegancki krój szeryfowy' },
	{ value: 'robotoMono', label: 'Roboto Mono', preview: 'Techniczny krój monospace' },
	{ value: 'poppins', label: 'Poppins', preview: 'Uniwersalny krój brandingowy' },
	{ value: 'lora', label: 'Lora', preview: 'Klasyczny szeryf o miękkich kształtach' },
	{ value: 'raleway', label: 'Raleway', preview: 'Delikatny, przestrzenny sans-serif' },
	{ value: 'leagueScript', label: 'League Script', preview: 'Lekki, odręczny podpis' },
	{ value: 'lobster', label: 'Lobster', preview: 'Mocny, dekoracyjny skrypt' },
	{ value: 'rougeScript', label: 'Rouge Script', preview: 'Elegancki, kaligraficzny krój' },
];

export const TEXT_ALIGNMENT_OPTIONS: { value: TextAlign; label: string }[] = [
	{ value: 'left', label: 'Do lewej' },
	{ value: 'center', label: 'Środek' },
	{ value: 'right', label: 'Do prawej' },
];

export const TEXT_FONT_STACK: Record<TextFontFamily, string> = {
	inter: '"Inter", "Segoe UI", sans-serif',
	montserrat: '"Montserrat", "Segoe UI", sans-serif',
	playfair: '"Playfair Display", "Times New Roman", serif',
	robotoMono: '"Roboto Mono", "SFMono-Regular", "Menlo", monospace',
	poppins: '"Poppins", "Helvetica Neue", sans-serif',
	lora: '"Lora", "Georgia", serif',
	raleway: '"Raleway", "Arial", sans-serif',
	leagueScript: '"League Script", "Brush Script MT", cursive',
	lobster: '"Lobster", "Brush Script MT", cursive',
	rougeScript: '"Rouge Script", "Brush Script MT", cursive',
};

export const DEFAULT_TEXT_COLOR = '#1f1f1f';
export const DEFAULT_TEXT_FONT_SIZE = 32;
export const DEFAULT_TEXT_ALIGN: TextAlign = 'center';
export const DEFAULT_TEXT_FONT: TextFontFamily = 'inter';
